/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DiscountInputs */

const en__field_discount = /** @type {(inputs: _Field_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount`)
};

const de__field_discount = /** @type {(inputs: _Field_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt`)
};

/**
* | output |
* | --- |
* | "Discount" |
*
* @param {_Field_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_discount = /** @type {((inputs?: _Field_DiscountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DiscountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_discount(inputs)
	return de__field_discount(inputs)
});